import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { Form, Errors, Control } from 'react-redux-form';
import { FormGroup, ControlLabel, Button, FormControl } from 'react-bootstrap';
import Select from '../../common/form/filtered-dropdown';
import Datepicker from '../../common/form/datepicker';

class DelinkForm extends Component {
  constructor(props) {
    super(props);

    this.id = this.props.outletId;
  }

  renderFooter() {
    return (
      <div className="fluid text-right">
        <Button type="submit" className="btn red-ghost-btn">Next</Button>
      </div>
    );
  }

  render() {
    const outlets = this.props.outlets;
    let value = this.props.selectedOutlet == undefined ? {
      value: '',
      label: ''
    } : {
      value: this.props.selectedOutlet.id,
      label: this.props.selectedOutlet.attributes.name
    };

    return (
      <Form model='deep.admin_delink' onSubmit={(payLoad) => this.props.handleSubmit(payLoad, outlets)}>
        <Errors className="errors" model="deep.admin_delink"/>
        <Panel footer={this.renderFooter()} className="mg-top-20">

          <FormGroup controlId="outlet">
            <label>Delink Single Outlet</label>
            <Select placeholder="Select Outlet"
                    onChange={this.props.handleSelectChange}
                    data={this.props.outlets.map((value) => {
                      return {
                        value: value.id,
                        label: value.attributes['customer-number'] + ' - ' +value.attributes['name']
                      }
                    })}
                    value={value}
                    isLoading={!this.props.fetched}
                    model="deep.admin_delink.outlet"/>
          </FormGroup>


          <FormGroup controlId="delink_date">
            <ControlLabel>Delink date*</ControlLabel>
            <Datepicker model="deep.admin_delink.delink_date"/>
          </FormGroup>


          <FormGroup controlId="delink_reason">
            <ControlLabel>Delink reason*</ControlLabel>
            <Control.text model=".delink_reason" component={FormControl} required/>
          </FormGroup>

          <FormGroup controlId="supress_notification">
            <label>
              <Control.checkbox model=".supress_notification"/>
              Suppress notifications
            </label>
          </FormGroup>
        </Panel>
      </Form>
    );
  }
}

export default (DelinkForm);



// WEBPACK FOOTER //
// ./src/components/admin/delink/delink-form.jsx